import { z } from "zod/v4";

import { ActionTypeSchema } from "../enums";

export const OptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const BaseUserInputNodeConfigSchema = z.object({
  model: z.string().optional(), // LanguageModel extends string
});

export const UserInputNodeTextPromptConfigSchema =
  BaseUserInputNodeConfigSchema.extend({
    type: z.literal("text"),
    prompt: z.string().optional(),
    variablePath: z.string(),
  });

export const UserInputNodeChoicePromptConfigSchema =
  BaseUserInputNodeConfigSchema.extend({
    type: z.literal("choice"),
    prompt: z.string().optional(),
    variablePath: z.string(),
    options: z.array(OptionSchema),
  });

export const UserInputNodeConfirmationPromptConfigSchema =
  BaseUserInputNodeConfigSchema.extend({
    type: z.literal("confirmation"),
    prompt: z.string().optional(),
    variablePath: z.string(),
  });

export const UserInputNodeFilePromptConfigSchema =
  BaseUserInputNodeConfigSchema.extend({
    type: z.literal("file"),
    prompt: z.string().optional(),
    variablePath: z.string(),
  });

export const UserInputNodeConfigSchema = z.discriminatedUnion("type", [
  UserInputNodeTextPromptConfigSchema,
  UserInputNodeChoicePromptConfigSchema,
  UserInputNodeConfirmationPromptConfigSchema,
  UserInputNodeFilePromptConfigSchema,
]);

export const InputRequirementSchema = z.object({
  type: ActionTypeSchema,
  configs: UserInputNodeConfigSchema.array(),
});

// TypeScript types inferred from Zod schemas
export type Option = z.infer<typeof OptionSchema>;
export type UserInputNodeTextPromptConfig = z.infer<
  typeof UserInputNodeTextPromptConfigSchema
>;
export type UserInputNodeChoicePromptConfig = z.infer<
  typeof UserInputNodeChoicePromptConfigSchema
>;
export type UserInputNodeConfirmationPromptConfig = z.infer<
  typeof UserInputNodeConfirmationPromptConfigSchema
>;
export type UserInputNodeConfig = z.infer<typeof UserInputNodeConfigSchema>;
export type InputRequirement = z.infer<typeof InputRequirementSchema>;
